import Model from './Model'

export default class Company extends Model {
  resource () { return 'companies' }
}
